import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import HasilInvestasi from '../HasilSimulasiSection/ManfaatBerkalaSection';
import {
    Container,
    FormWrap,
    FormContent,
    Form,
    FormInput,
    FormInputCustomLeft,
    FormLabel,
    FormButton,
    FormReset,
    FormSelect,
    FormOption,
    FormCardWrapper,
    FormDiv,
    FormRupiahLeft,
    FormSpanLeft,
    FormH2,
    FormH2Error,
    ResultDiv,
    FormH1
} from './SimulasiElements';

const ManfaatBerkalaSection = () => {
    const [formData, setFormData] = useState({
        tahun: '',
        kategori: '',
        dana_awal: '',
        paket_investasi: '',
        versi_penarikan: '',
    });
    const [paketInvestasi, setPaketInvestasi] = useState([]);
    const [kategoriData, setKategori] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasilInvestasi, setHasilInvestasi] = useState(null);
    const [data, setData] = useState([]);
    const [errors, setErrors] = useState({});
    const hasilInvestasiRef = useRef(null);

    useEffect(() => {
        const fetchPaketInvestasi = async () => {
            try {
                const paketAResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/parameter/INVESTASI_PAKET_A`);
                const paketBResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/parameter/INVESTASI_PAKET_B`);
                const paketCResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/parameter/INVESTASI_PAKET_C`);

                const paketA = paketAResponse.data.content.NUMERIC_VALUE;
                const paketB = paketBResponse.data.content.NUMERIC_VALUE;
                const paketC = paketCResponse.data.content.NUMERIC_VALUE;

                setPaketInvestasi([
                    { id: 'A', name: 'Paket Investasi A', code: paketA },
                    { id: 'B', name: 'Paket Investasi B', code: paketB },
                    { id: 'C', name: 'Paket Investasi C', code: paketC },
                ]);
            } catch (error) {
                console.error(error);
            }
        };

        const fetchKategori = async () => {
            try {
                const kategori = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/ter/category`);
                setKategori(kategori.data.content);
            } catch (error) {
                console.error(error);
            }
        };

        fetchPaketInvestasi();
        fetchKategori();
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: '' });
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.kategori) {
            newErrors.kategori = 'Kategori peserta wajib diisi.';
        }

        if (!formData.tahun || formData.tahun < 10) {
            newErrors.tahun = 'Jumlah tahun wajib diisi dan minimal 10 tahun.';
        }

        if (!formData.dana_awal || formData.dana_awal < 0) {
            newErrors.dana_awal = 'Dana awal wajib diisi dan tidak boleh kurang dari Rp 0.';
        }

        if (!formData.paket_investasi) {
            newErrors.paket_investasi = 'Pilihan paket investasi tidak boleh kosong.';
        }

        if (!formData.versi_penarikan) {
            newErrors.versi_penarikan = 'Penarikan bulanan peserta wajib diisi.';
        }

        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = validateForm();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setLoading(true);

        const { tahun, dana_awal, kategori, paket_investasi } = formData;

        const danaAwal = parseFloat(dana_awal);
        const bulan = parseInt(tahun) * 12;
        const pengembanganBulanan = parseFloat(paket_investasi) / 100 / 12;
        const biayaBulanan = 0.01 / 12;

        let saldo = danaAwal;
        const detailPerBulan = [];

        let totalPenarikan = 0;
        let totalPengembangan = 0;
        let totalBiaya = 0;
        let pajak = 0;
        let penarikanBulanan = 0;

        const kategoriInfo = kategoriData.find(cat => cat.id === parseInt(kategori));

        const resTer = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/ter/${kategoriInfo.kategori.toLowerCase()}`);
        const terList = resTer.data.content;

        const batasPajak = kategoriInfo?.jumlah || 0;

        for (let i = 1; i <= bulan; i++) {
            const tahunKe = Math.floor((i - 1) / 12);

            const pengembangan = saldo * pengembanganBulanan;
            const biaya = (saldo + pengembangan) * biayaBulanan;
            const dpb = saldo + pengembangan - biaya;

            // Hitung penarikan bulanan
            if (formData.versi_penarikan === 'sama') {
                if ((i - 1) % 12 === 0) {
                    const sisaBulan = bulan - (tahunKe * 12);
                    penarikanBulanan = dpb / sisaBulan;
                }
            } else if (formData.versi_penarikan === 'beda') {
                const sisaBulan = bulan - (i - 1);
                penarikanBulanan = dpb / sisaBulan;
            }

            const saldoAkhir = dpb - penarikanBulanan;

            let pajakBulanan = 0;

            if (formData.versi_penarikan === 'sama' && i % 12 === 0) {
                // Pajak khusus untuk bulan ke-12
                const penarikan12Bulan = detailPerBulan.slice(i - 12, i - 1).reduce((sum, item) => sum + parseFloat(item.penarikanBulanan), 0) + penarikanBulanan;
                const nilaiKenaPajak = penarikan12Bulan - batasPajak;

                let pajakTahunan = 0;
                if (nilaiKenaPajak > 0) {
                    if (nilaiKenaPajak <= 60000000) pajakTahunan = nilaiKenaPajak * 0.05;
                    else if (nilaiKenaPajak <= 250000000) pajakTahunan = nilaiKenaPajak * 0.15;
                    else if (nilaiKenaPajak <= 500000000) pajakTahunan = nilaiKenaPajak * 0.25;
                    else if (nilaiKenaPajak <= 5000000000) pajakTahunan = nilaiKenaPajak * 0.30;
                    else pajakTahunan = nilaiKenaPajak * 0.35;
                }

                const pajak11Bulan = detailPerBulan.slice(i - 12, i - 1).reduce((sum, item) => sum + parseFloat(item.pajak), 0);
                pajakBulanan = pajakTahunan - pajak11Bulan;
                if (pajakBulanan < 0) pajakBulanan = 0;
            } else if (formData.versi_penarikan === 'beda' && i % 12 === 0) {
                // Pajak khusus untuk bulan ke-12
                const penarikan12Bulan = detailPerBulan.slice(i - 12, i - 1).reduce((sum, item) => sum + parseFloat(item.penarikanBulanan), 0) + penarikanBulanan;
                const nilaiKenaPajak = penarikan12Bulan - batasPajak;

                let pajakTahunan = 0;
                if (nilaiKenaPajak > 0) {
                    if (nilaiKenaPajak <= 60000000) pajakTahunan = nilaiKenaPajak * 0.05;
                    else if (nilaiKenaPajak <= 250000000) pajakTahunan = nilaiKenaPajak * 0.15;
                    else if (nilaiKenaPajak <= 500000000) pajakTahunan = nilaiKenaPajak * 0.25;
                    else pajakTahunan = nilaiKenaPajak * 0.30;
                }

                const pajak11Bulan = detailPerBulan.slice(i - 12, i - 1).reduce((sum, item) => sum + parseFloat(item.pajak), 0);
                pajakBulanan = pajakTahunan - pajak11Bulan;
                if (pajakBulanan < 0) pajakBulanan = 0;
            } else {
                // Pajak reguler dari terList
                const match = terList.find(item => penarikanBulanan >= item.tarif_bawah && penarikanBulanan <= item.tarif_atas);
                pajakBulanan = match ? penarikanBulanan * parseFloat(match.pajak) : 0;
            }

            // Hitung pajak dari penarikanBulanan
            const match = terList.find(item => penarikanBulanan >= item.tarif_bawah && penarikanBulanan <= item.tarif_atas);
            const persenPajakBulanan = match ? (parseFloat(match.pajak)) : 0;

            totalPenarikan += penarikanBulanan;
            saldo = saldoAkhir;
            pajak += pajakBulanan;
            const penarikanBersih = penarikanBulanan - pajakBulanan;
            totalPengembangan += pengembangan;
            totalBiaya += biaya;

            detailPerBulan.push({
                bulan: i,
                saldo: i === 1 ? danaAwal.toFixed(2) : detailPerBulan[i - 2].saldoAkhir,
                pengembangan: pengembangan.toFixed(2),
                biaya: biaya.toFixed(2),
                dpb: dpb.toFixed(2),
                penarikanBulanan: penarikanBulanan.toFixed(2),
                saldoAkhir: saldoAkhir.toFixed(2),
                tarifPajak: (persenPajakBulanan * 100).toFixed(2),
                pajak: pajakBulanan.toFixed(2),
                penarikanBersih: penarikanBersih.toFixed(2),
            });
        }

        const pajakManfaatSekaligus = dana_awal <= 50000000 ? 0 : (dana_awal - 50000000) * 0.05;

        setTimeout(() => {
            setHasilInvestasi({
                totalDana: (parseFloat(dana_awal)).toFixed(2),
                pajakSekaligus: pajakManfaatSekaligus.toFixed(2),
                pengembangan: totalPengembangan.toFixed(2),
                biaya: totalBiaya.toFixed(2),
                pajakBerkala: pajak.toFixed(2),
                totalPenarikan: (parseFloat(totalPenarikan)).toFixed(2),
            });
            setData(detailPerBulan);
            setLoading(false);
            scrollToHasilInvestasi();
        }, 1000);
    };

    const resetForm = () => {
        setFormData({
            tahun: '',
            kategori: '',
            dana_awal: '',
            paket_investasi: '',
            versi_penarikan: ''
        });
        setData([]);
        setErrors({});
    };

    const scrollToHasilInvestasi = () => {
        if (hasilInvestasiRef.current) {
            hasilInvestasiRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <>
            <Container>
                <FormWrap>
                    <FormContent>
                        <FormH1>Simulasi Manfaat Berkala</FormH1>
                        <Form onSubmit={handleSubmit}>
                            <FormCardWrapper>
                                <FormDiv>
                                    <FormLabel htmlFor="kategori">Kategori Peserta</FormLabel>
                                    <FormSelect id="kategori" name="kategori" value={formData.kategori} onChange={handleChange}>
                                        <FormOption value="" disabled>Pilih Kategori Peserta</FormOption>
                                        {kategoriData.map((cat) => (
                                            <FormOption key={cat.id} value={cat.id}>{cat.name}</FormOption>
                                        ))}
                                    </FormSelect>
                                    {errors.kategori && <FormH2Error>{errors.kategori}</FormH2Error>}

                                    <FormLabel htmlFor="dana_awal">Dana Awal</FormLabel>
                                    <FormRupiahLeft>
                                        <FormSpanLeft>Rp</FormSpanLeft>
                                        <FormInputCustomLeft id="dana_awal" type="text" name="dana_awal" value={formData.dana_awal} onChange={handleChange} />
                                    </FormRupiahLeft>
                                    {errors.dana_awal && <FormH2Error>{errors.dana_awal}</FormH2Error>}

                                    <FormLabel htmlFor="tahun">Durasi Manfaat Berkala (Tahun)</FormLabel>
                                    <FormInput id="tahun" name="tahun" value={formData.tahun} onChange={handleChange} />
                                    {errors.tahun && <FormH2Error>{errors.tahun}</FormH2Error>}

                                    <FormLabel>Penarikan Bulanan</FormLabel>
                                    <FormSelect name="versi_penarikan" value={formData.versi_penarikan} onChange={handleChange}>
                                        <FormOption value="" disabled>Pilih Penarikan Bulanan</FormOption>
                                        <FormOption value="sama">Penarikan Bulanan Sama</FormOption>
                                        <FormOption value="beda">Penarikan Bulanan Berbeda</FormOption>
                                    </FormSelect>
                                    {errors.versi_penarikan && <FormH2Error>{errors.versi_penarikan}</FormH2Error>}
                                </FormDiv>
                                <FormDiv>
                                    <FormLabel htmlFor="paket_investasi">Tingkat Investasi</FormLabel>
                                    <FormSelect id="paket_investasi" name="paket_investasi" value={formData.paket_investasi} onChange={handleChange}>
                                        <FormOption value="" disabled>Pilih Tingkat Investasi</FormOption>
                                        {paketInvestasi.map((paket) => (
                                            <FormOption key={paket.id} value={paket.code}>{paket.code}%</FormOption>
                                        ))}
                                    </FormSelect>
                                    {errors.paket_investasi && <FormH2Error>{errors.paket_investasi}</FormH2Error>}

                                    <FormLabel htmlFor="biaya_pengelolaan">Biaya Pengelolaan</FormLabel>
                                    <FormInput id="biaya_pengelolaan" name="biaya_pengelolaan" value={formData.biaya_pengelolaan} placeholder="Asumsi 1% dari akumulasi dana per tahun" onChange={handleChange} disabled />
                                    <FormH2><i>Biaya dapat berubah sewaktu-waktu.</i></FormH2>

                                    <FormButton type="submit" disabled={loading}>{loading ? 'Loading...' : 'Hitung Simulasi'}</FormButton>
                                    <FormReset type="button" onClick={resetForm}>Reset</FormReset>
                                </FormDiv>
                            </FormCardWrapper>
                        </Form>
                        <ResultDiv ref={hasilInvestasiRef}>
                            {data.length > 0 && <HasilInvestasi hasilInvestasi={hasilInvestasi} data={data} />}
                        </ResultDiv>
                    </FormContent>
                </FormWrap>
            </Container>
        </>
    );
};

export default ManfaatBerkalaSection;